<script>
    import Cinema from "../components/Cinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        contextDresonRule,
        timelineEntryId,
        index,
        pageType,
        featureIndex,
        removeSkeleton,
        errorCallback,
        performance,
        cinemaInjectionContainerWidth,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
        view = null,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let contentDresonRule = $state(),
        headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state(),
        backgroundColor = $state(),
        hasPersonalisedRecommendations = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const indexParam = index ? `&index=${index}` : "";
        const timelineEntryIdParam = timelineEntryId ? `&timelineEntryId=${timelineEntryId}` : "";
        const pageTypeParam = pageType === "LOGOUT" ? `&isLogout=true` : "";
        const viewParam = view ? `&view=${view}` : "";
        const parameters = `${indexParam}${pageTypeParam}${timelineEntryIdParam}${viewParam}`;
        const res = await ajaxFetch(
            `/reco-core/recommendations/dreson?encodedDresonRule=${contextDresonRule}${parameters}`
        );
        removeSkeleton();
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            dreson: contentDresonRule,
            headline,
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            featuresState,
            backgroundColor,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_entry_page_cinema_wrapper" style:background-color={backgroundColor}>
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {performance}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            site="reco_entryPage"
            {contentDresonRule}
            personalisedUser={hasPersonalisedRecommendations}
        />
    </div>
{/if}

<style lang="scss">
    .reco_entry_page_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;
    }
</style>
